import { render, staticRenderFns } from "./DeployFooter.vue?vue&type=template&id=63c27336&scoped=true"
import script from "./DeployFooter.vue?vue&type=script&lang=ts"
export * from "./DeployFooter.vue?vue&type=script&lang=ts"
import style0 from "./DeployFooter.vue?vue&type=style&index=0&id=63c27336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c27336",
  null
  
)

export default component.exports